export default [
  {
    path: '/odometerForm',//年度到达里程表
    name: 'odometerForm',
    component: () => import('@/views/reportForms/odometerForm/odometerForm.vue'),
    redirect: { name: 'odometerByTechnologyLevel' },
    meta: { keepAlive: false },
    children: [
      {
        path: 'odometerByTechnologyLevel',//按技术等级划分 odometerByTechnologyLevel
        name: 'odometerByTechnologyLevel',
        component: () => import('@/views/reportForms/odometerForm/odometerByTechnologyLevel/odometerByTechnologyLevel.vue'),
        redirect: { name: 'technologyLevel' },
        children: [
          {
            path: 'technologyLevel',//按技术等级划分 首页 technologyLevel
            name: 'technologyLevel',
            component: () => import('@/views/reportForms/odometerForm/odometerByTechnologyLevel/technologyLevel.vue'),
            meta: {
              keepAlive: false, title: '公路里程数据统计(按技术等级划分)',
              auth: true
            }
          },
          {
            path: 'lineWayByTechnologyLevel',//线路数据 首页 lineWayByTechnologyLevel
            name: 'lineWayByTechnologyLevel',
            component: () => import('@/views/reportForms/odometerForm/odometerByTechnologyLevel/lineWayByTechnologyLevel.vue'),
            meta: {
              keepAlive: false, title: '路线表(按技术等级划分)',
              auth: true
            }
          }
        ]
      },
      {
        path: 'odometerByRouteType',//按路线划分 odometerByRouteType
        name: 'odometerByRouteType',
        component: () => import('@/views/reportForms/odometerForm/odometerByRouteType/odometerByRouteType.vue'),
        redirect: { name: 'routeType' },
        children: [
          {
            path: 'routeType',//按路线划分 首页 routeType
            name: 'routeType',
            component: () => import('@/views/reportForms/odometerForm/odometerByRouteType/routeType.vue'),
            meta: {
              keepAlive: false, title: '公路里程数据统计(按路线划分)',
              auth: true
            }
          },
          {
            path: 'lineWayByRouteType',//按路线划分 首页 lineWayByRouteType
            name: 'lineWayByRouteType',
            component: () => import('@/views/reportForms/odometerForm/odometerByRouteType/lineWayByRouteType.vue'),
            meta: {
              keepAlive: false, title: '路线表(按路线划分)',
              auth: true
            }
          }
        ]
      },
      {
        path: 'odometerByWayType',//按路面类型划分 odometerByWayType
        name: 'odometerByWayType',
        component: () => import('@/views/reportForms/odometerForm/odometerByWayType/odometerByWayType.vue'),
        redirect: { name: 'wayType' },
        meta: { keepAlive: false },
        children: [
          {
            path: 'wayType',//按路面类型划分 首页 wayType
            name: 'wayType',
            component: () => import('@/views/reportForms/odometerForm/odometerByWayType/wayType.vue'),
            meta: {
              keepAlive: false, title: '公路里程数据统计(按路面类型划分)',
              auth: true
            }
          },
          {
            path: 'lineWayByWayType',//按路面类型划分 首页 lineWayByWayType
            name: 'lineWayByWayType',
            component: () => import('@/views/reportForms/odometerForm/odometerByWayType/lineWayByWayType.vue'),
            meta: {
              keepAlive: false, title: '路线表(按路面类型划分)',
              auth: true
            }
          }
        ]
      },
      {
        path: 'odometerByTypeUnit',//按管养单位划分 odometerByTypeUnit
        name: 'odometerByTypeUnit',
        component: () => import('@/views/reportForms/odometerForm/odometerByTypeUnit/odometerByTypeUnit.vue'),
        redirect: { name: 'typeUnit' },
        meta: { keepAlive: false },
        children: [
          {
            path: 'typeUnit',//按管养单位划分 首页 TypeUnit
            name: 'typeUnit',
            component: () => import('@/views/reportForms/odometerForm/odometerByTypeUnit/typeUnit.vue'),
            meta: {
              keepAlive: false, title: '公路里程数据统计(按管养单位划分)',
              auth: true
            }
          },
          {
            path: 'lineWayByTypeUnit',//按管养单位划分 首页 lineWayByTypeUnit
            name: 'lineWayByTypeUnit',
            component: () => import('@/views/reportForms/odometerForm/odometerByTypeUnit/lineWayByTypeUnit.vue'),
            meta: {
              keepAlive: false, title: '路线表(按管养单位划分)',
              auth: true
            }
          },
          {
            path: 'lineWayByrouteType',//按管养单位划分 首页 lineWayByTypeUnit
            name: 'lineWayByrouteType',
            component: () => import('@/views/reportForms/odometerForm/odometerByTypeUnit/lineWayByrouteType.vue'),
            meta: {
              keepAlive: false, title: '路线表(按路线划分)',
              auth: true
            }
          }
        ]
      }
    ]
  },

  //2023-5-09（yjj）
  {
    path: '/routeForm',//路段数据表
    name: 'routeForm',//数据 导出 复核
    component: () => import('@/views/reportForms/routeForm/routeForm.vue'),
    meta: {
      keepAlive: false, title: '线路路段',
      auth: true
    },
  },
  {
    path: '/routeFormAll',//路段数据表
    name: 'routeFormAll',//数据 导出 复核
    component: () => import('@/views/reportForms/routeFormAll/routeFormAll.vue'),
    meta: {
      keepAlive: false, title: '线路路段（汇总）',
      auth: true
    },
  },
  {
    path: '/bridgeStatisticsForm',//桥梁统计数据
    name: 'bridgeStatisticsForm',//数据 导出 复核
    component: () => import('@/views/reportForms/bridgeStatisticsForm/bridgeStatisticsForm.vue'),
    meta: {
      keepAlive: false, title: '桥梁统计数据',
      auth: true
    },
  },
  {
    path: '/bridgeStatisticsFormSubordinatePage',//桥梁统计数据
    name: 'bridgeStatisticsFormSubordinatePage',//数据 导出 复核
    component: () => import('@/views/reportForms/bridgeStatisticsFormSubordinatePage/bridgeStatisticsFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '桥梁统计数据',
      auth: true
    },
  },
  {
    path: '/bridgeStatisticsFormHeadeSubordinatePage',//桥梁统计数据
    name: 'bridgeStatisticsFormHeadeSubordinatePage',//数据 导出 复核
    component: () => import('@/views/reportForms/bridgeStatisticsFormHeadeSubordinatePage/bridgeStatisticsFormHeadeSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '桥梁统计数据分类明细',
      auth: true
    },
  },
  {
    path: '/tunnelStatisticsForm',//隧道统计数据
    name: 'tunnelStatisticsForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/tunnelStatisticsForm/tunnelStatisticsForm.vue'),
    meta: {
      keepAlive: false, title: '隧道统计数据',
      auth: true
    },
  },
  {
    path: '/tunnelStatisticsFormSubordinatePage',//隧道统计数据
    name: 'tunnelStatisticsFormSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/tunnelStatisticsFormSubordinatePage/tunnelStatisticsFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '隧道统计数据',
      auth: true
    },
  },
  {
    path: '/tunnelStatisticsFormHeadeSubordinatePage',//隧道统计数据
    name: 'tunnelStatisticsFormHeadeSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/tunnelStatisticsFormHeadeSubordinatePage/tunnelStatisticsFormHeadeSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '隧道统计数据分类明细',
      auth: true
    },
  },
  {
    path: '/culvertStatisticsForm',//涵洞统计报表
    name: 'culvertStatisticsForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/culvertStatisticsForm/culvertStatisticsForm.vue'),
    meta: {
      keepAlive: false, title: '涵洞统计报表',
      auth: true
    },
  },
  {
    path: '/culvertStatisticsFormSubordinatePage',//涵洞统计报表
    name: 'culvertStatisticsFormSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/culvertStatisticsFormSubordinatePage/culvertStatisticsFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '涵洞统计报表',
      auth: true
    },
  },
  {
    path: '/culvertStatisticsFormHeadeSubordinatePage',//涵洞统计报表
    name: 'culvertStatisticsFormHeadeSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/culvertStatisticsFormHeadeSubordinatePage/culvertStatisticsFormHeadeSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '涵洞统计报表数据分类明细',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleForm',//交安设施管理  数据 导出
    name: 'jiaoAnAssembleForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleForm/jiaoAnAssembleForm.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormSubordinatePage',//交安设施管理  数据 导出
    name: 'jiaoAnAssembleFormSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormSubordinatePage/jiaoAnAssembleFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理分类明细',
      auth: true
    },
  },
  //2023-05-11
  {
    path: '/jiaoAnAssembleFormMarking',//交安设施管理(标线) 数据 导出
    name: 'jiaoAnAssembleFormMarking',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormMarking/jiaoAnAssembleFormMarking.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(标线)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormMarkingSubordinatePage',//交安设施管理(标线) 数据 导出
    name: 'jiaoAnAssembleFormMarkingSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormMarkingSubordinatePage/jiaoAnAssembleFormMarkingSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(标线)分类明细',
      auth: true
    },
  },
  
  {
    path: '/jiaoAnAssembleFormGuardrail',//交安设施管理(护栏) 数据 导出
    name: 'jiaoAnAssembleFormGuardrail',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormGuardrail/jiaoAnAssembleFormGuardrail.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(护栏)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormGuardrailSubordinatePage',//交安设施管理(护栏) 数据 导出
    name: 'jiaoAnAssembleFormGuardrailSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormGuardrailSubordinatePage/jiaoAnAssembleFormGuardrailSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(护栏)分类明细',
      auth: true
    },
  },
  //2023-05-11
  {
    path: '/jiaoAnAssembleFormTrafficstandards',//交安设施管理(道路交通标志) 数据 导出
    name: 'jiaoAnAssembleFormTrafficstandards',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormTrafficstandards/jiaoAnAssembleFormTrafficstandards.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(道路交通标志)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormTrafficstandardsSubordinatePage',//交安设施管理(道路交通标志) 数据 导出
    name: 'jiaoAnAssembleFormTrafficstandardsSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormTrafficstandardsSubordinatePage/jiaoAnAssembleFormTrafficstandardsSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(道路交通标志)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormAntiGlareBoard',//交安设施管理(防眩板)  数据 导出
    name: 'jiaoAnAssembleFormAntiGlareBoard',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAntiGlareBoard/jiaoAnAssembleFormAntiGlareBoard.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(防眩板)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormAntiGlareBoardSubordinatePage',//交安设施管理(防眩板)  数据 导出
    name: 'jiaoAnAssembleFormAntiGlareBoardSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAntiGlareBoardSubordinatePage/jiaoAnAssembleFormAntiGlareBoardSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(防眩板)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormAntiGlareNet',//交安设施管理(防眩网)  数据 导出
    name: 'jiaoAnAssembleFormAntiGlareNet',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAntiGlareNet/jiaoAnAssembleFormAntiGlareNet.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(防眩网)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormAntiGlareNetSubordinatePage',//交安设施管理(防眩网)  数据 导出
    name: 'jiaoAnAssembleFormAntiGlareNetSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAntiGlareNetSubordinatePage/jiaoAnAssembleFormAntiGlareNetSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(防眩网)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormVariableMessageSign',//交安设施管理(可变情报板) 数据 导出
    name: 'jiaoAnAssembleFormVariableMessageSign',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormVariableMessageSign/jiaoAnAssembleFormVariableMessageSign.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(可变情报板)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormVariableMessageSignSubordinatePage',//交安设施管理(可变情报板) 数据 导出
    name: 'jiaoAnAssembleFormVariableMessageSignSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormVariableMessageSignSubordinatePage/jiaoAnAssembleFormVariableMessageSignSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(可变情报板)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormActivityGuardrail',//交安设施管理(活动护栏) 数据 导出
    name: 'jiaoAnAssembleFormActivityGuardrail',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormActivityGuardrail/jiaoAnAssembleFormActivityGuardrail.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(活动护栏)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormActivityGuardrailSubordinatePage',//交安设施管理(活动护栏) 数据 导出
    name: 'jiaoAnAssembleFormActivityGuardrailSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormActivityGuardrailSubordinatePage/jiaoAnAssembleFormActivityGuardrailSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(活动护栏)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormIsolationBarrier',//交安设施管理(隔离栅) 数据 导出
    name: 'jiaoAnAssembleFormIsolationBarrier',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormIsolationBarrier/jiaoAnAssembleFormIsolationBarrier.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(隔离栅)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormIsolationBarrierSubordinatePage',//交安设施管理(隔离栅) 数据 导出
    name: 'jiaoAnAssembleFormIsolationBarrierSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormIsolationBarrierSubordinatePage/jiaoAnAssembleFormIsolationBarrierSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(隔离栅)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormBridgeProtectionNet',//交安设施管理(桥梁防护网) 数据 导出
    name: 'jiaoAnAssembleFormBridgeProtectionNet',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormBridgeProtectionNet/jiaoAnAssembleFormBridgeProtectionNet.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(桥梁防护网)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormBridgeProtectionNetSubordinatePage',//交安设施管理(桥梁防护网) 数据 导出
    name: 'jiaoAnAssembleFormBridgeProtectionNetSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormBridgeProtectionNetSubordinatePage/jiaoAnAssembleFormBridgeProtectionNetSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(桥梁防护网)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormHundredMeterSignStake',//交安设施管理(百米牌（桩）) 数据 导出 
    name: 'jiaoAnAssembleFormHundredMeterSignStake',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormHundredMeterSignStake/jiaoAnAssembleFormHundredMeterSignStake.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(百米牌（桩）)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormHundredMeterSignStakeSubordinatePage',//交安设施管理(百米牌（桩）) 数据 导出 
    name: 'jiaoAnAssembleFormHundredMeterSignStakeSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormHundredMeterSignStakeSubordinatePage/jiaoAnAssembleFormHundredMeterSignStakeSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(百米牌（桩）)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormAttachedContourMarkers',//交安设施管理(附着式轮廓标)  数据 导出 
    name: 'jiaoAnAssembleFormAttachedContourMarkers',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAttachedContourMarkers/jiaoAnAssembleFormAttachedContourMarkers.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(附着式轮廓标)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormAttachedContourMarkersSubordinatePage',//交安设施管理(附着式轮廓标)  数据 导出 
    name: 'jiaoAnAssembleFormAttachedContourMarkersSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormAttachedContourMarkersSubordinatePage/jiaoAnAssembleFormAttachedContourMarkersSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(附着式轮廓标)分类明细',
      auth: true
    },
  },

  {
    path: '/jiaoAnAssembleFormColumnarDelineators',//交安设施管理(柱式轮廓标) 数据 导出 
    name: 'jiaoAnAssembleFormColumnarDelineators',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormColumnarDelineators/jiaoAnAssembleFormColumnarDelineators.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(柱式轮廓标)',
      auth: true
    },
  },
  {
    path: '/jiaoAnAssembleFormColumnarDelineatorsSubordinatePage',//交安设施管理(柱式轮廓标) 数据 导出 
    name: 'jiaoAnAssembleFormColumnarDelineatorsSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/jiaoAnAssembleFormColumnarDelineatorsSubordinatePage/jiaoAnAssembleFormColumnarDelineatorsSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '交安设施管理(柱式轮廓标)分类明细',
      auth: true
    },
  },
  //2023-05-15
  {
    path: '/complementaryAssetsForm',//辅助资产统计数据 数据 导出 
    name: 'complementaryAssetsForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/complementaryAssetsForm/complementaryAssetsForm.vue'),
    meta: {
      keepAlive: false, title: '辅助资产统计数据',
      auth: true
    },
  },
  {
    path: '/complementaryAssetsFormSubordinatePage',//辅助资产统计数据 数据 导出 
    name: 'complementaryAssetsFormSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/complementaryAssetsFormSubordinatePage/complementaryAssetsFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '辅助资产统计数据分类明细',
      auth: true
    },
  },

  {
    path: '/curingMaterialsForm',//养护材料统计数据 
    name: 'curingMaterialsForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/curingMaterialsForm/curingMaterialsForm.vue'),
    meta: {
      keepAlive: false, title: '养护材料统计数据',
      auth: true
    },
  },
  {
    path: '/materialInboundAndOutboundForm',//根据养护材料出入库流水
    name: 'materialInboundAndOutboundForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/materialInboundAndOutboundForm/materialInboundAndOutboundForm.vue'),
    meta: {
      keepAlive: false, title: '根据养护材料出入库流水',
      auth: true
    },
  },
  {
    path: '/mechanicalEquipmentForm',//机械设备统计数据
    name: 'mechanicalEquipmentForm',//数据 导出 复核 
    component: () => import('@/views/reportForms/mechanicalEquipmentForm/mechanicalEquipmentForm.vue'),
    meta: {
      keepAlive: false, title: '机械设备统计数据',
      auth: true
    },
  },
  {
    path: '/mechanicalEquipmentFormSubordinatePage',//机械设备统计数据   下级页面
    name: 'mechanicalEquipmentFormSubordinatePage',//数据 导出 复核 
    component: () => import('@/views/reportForms/mechanicalEquipmentFormSubordinatePage/mechanicalEquipmentFormSubordinatePage.vue'),
    meta: {
      keepAlive: false, title: '设备台账统计数据',
      auth: true
    },
  },
  {
    path: '/maintenanceMonthlyReportSummary',//维修月报
    name: 'maintenanceMonthlyReportSummary',//
    component: () => import('@/views/reportForms/maintenanceMonthlyReportSummary/maintenanceMonthlyReportSummary.vue'),
    meta: {
      keepAlive: false, title: '维修月报',
      auth: true
    },
  },
]